import React from 'react';
import { array, bool, func, string } from 'prop-types';

import LoadingState from '../../../LoadingState';
import PastAppointmentItem from './PastAppointmentItem/PastAppointmentItemContainer';

import s from './PastAppointmentsContainer.css';


const PastAppointmentsContainer = ({ ...props }) => {

  // Render UpcomingAppointmentItem when they are available, otherwise display a placeholder message.
  const getPastAppointments = () => {
    const pastAppointments = props.pastAppointments;
    const noPastAppointments = (props.pastAppointments.length === 0);

    const messagePlaceholder = (
      <p className={s.messagePlaceholder}>
        We could not locate your Past Appointments at this time.
      </p>
    );

    const pastAppointmentItem = pastAppointments.map((appt) =>
      <PastAppointmentItem
        appt={appt}
        defaultEmailRecipient={props.defaultEmailRecipient}
        email={props.email}
        hideFullPageLoadingState={props.hideFullPageLoadingState}
        key={appt.id}
        possibleMessageRecipients={props.possibleMessageRecipients}
        sendAppointmentMessage={props.sendAppointmentMessage}
        showFullPageLoadingState={props.showFullPageLoadingState}
      />
    );

    // No Upcoming Appointments, render placeholder, else render UpcomingAppointmentItem
    return noPastAppointments ? messagePlaceholder : pastAppointmentItem;
  };

  if (props.loadingState) {
    return (
      <section className={s.component} id="pastAppointmentsContainer__loading">
        <h3 className={s.header}>
          Past Appointments
        </h3>
        <p className={s.messagePlaceholder}>
          Loading your Past Appointments...
        </p>
        <LoadingState context="pastAppointments" />
      </section>
    );
  }

  return (
    <section className={s.component} id="pastAppointmentsContainer">
      <h3 className={s.header}>
        Past Appointments
      </h3>
      {getPastAppointments()}
    </section>
  );

};

PastAppointmentsContainer.propTypes = {
  defaultEmailRecipient: string,
  email: func,
  hideFullPageLoadingState: func,
  loadingState: bool,
  pastAppointments: array,
  possibleMessageRecipients: array,
  sendAppointmentMessage: func,
  showFullPageLoadingState: func,
};

export default PastAppointmentsContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/PastAppointments/PastAppointmentsContainer.js